import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { when } from "@/lib/rides";
import { PageHead } from "@/pages/admin/AdminLayout";
import { Input } from "@/components/ui/input";

const short = (v) => (v == null ? "—" : JSON.stringify(v).slice(0, 160));

export default function AdminAudit() {
  const [type, setType] = useState("");
  const [action, setAction] = useState("");
  const { data } = useQuery({ queryKey: ["audit", type, action], queryFn: () => api.get("/admin/audit", { params: { entity_type: type || undefined, action: action || undefined } }).then((r) => r.data) });
  return (
    <div className="fade-up" data-testid="admin-audit">
      <PageHead title="Audit history" sub="Who did what, when — with previous and new values.">
        <select value={type} onChange={(e) => setType(e.target.value)} className="h-9 rounded-md border bg-background px-2 text-sm" data-testid="audit-type-filter">
          <option value="">All records</option><option value="ride">Rides</option><option value="user">Users</option><option value="pricing">Pricing</option><option value="location">Directory</option>
        </select>
        <Input placeholder="Action contains…" value={action} onChange={(e) => setAction(e.target.value)} className="h-9 w-48" data-testid="audit-action-filter" />
      </PageHead>
      <div className="divide-y rounded-xl border bg-card">
        {data?.map((a) => (
          <div key={a.id} className="grid gap-1 p-3 text-xs md:grid-cols-[160px_180px_1fr]" data-testid="audit-row">
            <span className="text-muted-foreground">{when(a.at)}</span>
            <span><span className="font-semibold">{a.action.replace(/_/g, " ")}</span><br /><span className="text-muted-foreground">{a.actor_email}</span></span>
            <span className="font-mono text-muted-foreground">{a.entity_type}{a.entity_id ? ` ${a.entity_id.slice(-6)}` : ""} · before {short(a.before)} → after {short(a.after)}{a.note ? ` · ${a.note}` : ""}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
